import { toast } from "react-toastify";
import { parseError } from "shared/src/helpers/errorHandler";

export const handleSagaError = (e: any) => {
  const { message, code } = parseError(e);
  toast.error(message ?? code);
};
